<template>
    <div :class="[headerClasses, { 'min-[576px]:pt-4 min-[576px]:pb-4': titleInAppHeader }]" class="sticky-header">
        <row>
            <column>
                <template v-if="titleInAppHeader">
                    <teleport defer to="#app-header-page-title">
                        <page-title
                            v-if="title"
                            :class="titleClasses"
                            :heading-classes="promotedTitleHeadingClasses"
                            :title="title"
                            class="app-header-page-title w-full min-w-0"
                            variant="inverse"
                        />
                    </teleport>
                    <div id="page-header-action" class="mb-6 flex max-w-full items-start justify-end gap-6 pb-6 [&:empty]:hidden" />
                </template>
                <div v-else class="mb-6 flex max-w-full items-start justify-between gap-6 pb-6">
                    <page-title :class="titleClasses" :title="title" />
                    <div id="page-header-action" />
                </div>
                <slot />
            </column>
        </row>
    </div>
</template>
<script setup>
import PageTitle from '@/Components/PageTitle.vue';

const promotedTitleHeadingClasses =
    '!mb-0 !min-h-0 overflow-hidden text-ellipsis whitespace-nowrap text-left !text-base !leading-tight min-[768px]:text-center min-[768px]:!text-2xl min-[768px]:!leading-[1.25]';

defineProps({
    title: String,
    headerClasses: { type: [Array, Object, String] },
    titleClasses: { type: [Array, Object, String] },
    titleInAppHeader: {
        type: Boolean,
        default: false,
    },
});
</script>
